import { CommonConstants } from "@/common/constants"

const baseUrl = process.env.VUE_APP_DOMAIN_URL

const ICONS = [
  {
    "src": "https://sdksrv.obs.cn-north-1.myhuaweicloud.com/mall-static/mall-icon.png",
    "sizes": "192x192",
    "type": "image/png"
  },
  {
    "src": "https://sdksrv.obs.cn-north-1.myhuaweicloud.com/mall-static/mall-icon.png",
    "sizes": "512x512",
    "type": "image/png"
  }
]

const manifestCn = {
  "name": "英雄游戏支付中心",
  "short_name": "英雄游戏支付中心",
  "start_url": baseUrl,
  "scope": baseUrl,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestGlobal = {
  "name": "Hero Games Store",
  "short_name": "Hero Games Store",
  "start_url": baseUrl,
  "scope": baseUrl,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestWpzz = {
  "name": "王牌战争-英雄游戏支付中心",
  "short_name": "王牌战争-英雄游戏支付中心",
  "start_url": `${baseUrl}/wpzz`,
  "scope": `${baseUrl}/wpzz`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestCncm = {
  "name": "创造与魔法-英雄游戏支付中心",
  "short_name": "创造与魔法-英雄游戏支付中心",
  "start_url": `${baseUrl}/cncm`,
  "scope": `${baseUrl}/cncm`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestDna = {
  "name": "二重螺旋-英雄游戏支付中心",
  "short_name": "二重螺旋-英雄游戏支付中心",
  "start_url": `${baseUrl}/dna`,
  "scope": `${baseUrl}/dna`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestEe = {
  "name": "Eternal Evolution - Hero Games Store",
  "short_name": "Eternal Evolution - Hero Games Store",
  "start_url": `${baseUrl}/ee`,
  "scope": `${baseUrl}/ee`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestKree = {
  "name": "이터널 에볼루션 - Hero Games Store",
  "short_name": "이터널 에볼루션 - Hero Games Store",
  "start_url": `${baseUrl}/kree`,
  "scope": `${baseUrl}/kree`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

// const manifestAuroria = {
//   "name": "Auroria - Hero Games Store",
//   "short_name": "Auroria - Hero Games Store",
//   "start_url": `${baseUrl}/auroria`,
//   "scope": `${baseUrl}/auroria`,
//   "display": "standalone",
//   "background_color": "#ffffff",
//   "icons": ICONS
// }

const manifestLios = {
  "name": "Last Island Of Survival - Hero Games Store",
  "short_name": "Last Island Of Survival - Hero Games Store",
  "start_url": `${baseUrl}/lios`,
  "scope": `${baseUrl}/lios`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestLioslite = {
  "name": "Last Island Of Survival LITE - Hero Games Store",
  "short_name": "Last Island Of Survival LITE - Hero Games Store",
  "start_url": `${baseUrl}/lioslite`,
  "scope": `${baseUrl}/lioslite`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestSd2 = {
  "name": "Summon Dragons 2 - Hero Games Store",
  "short_name": "Summon Dragons 2 - Hero Games Store",
  "start_url": `${baseUrl}/sd2`,
  "scope": `${baseUrl}/sd2`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestShinsangokushi = {
  "name": "新三國志 - Hero Games Store",
  "short_name": "新三國志 - Hero Games Store",
  "start_url": `${baseUrl}/shinsangokushi`,
  "scope": `${baseUrl}/shinsangokushi`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestShinsangokushinew = {
  "name": "新三國志-英雄游戏支付中心",
  "short_name": "新三國志-英雄游戏支付中心",
  "start_url": `${baseUrl}/shinsangokushinew`,
  "scope": `${baseUrl}/shinsangokushinew`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestTwee = {
  "name": "天演進化 - Hero Games Store",
  "short_name": "天演進化 - Hero Games Store",
  "start_url": `${baseUrl}/twee`,
  "scope": `${baseUrl}/twee`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestTwwtb = {
  "name": "烏托邦：起源 - Hero Games Store",
  "short_name": "烏托邦：起源 - Hero Games Store",
  "start_url": `${baseUrl}/twwtb`,
  "scope": `${baseUrl}/twwtb`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestNobunaga = {
  "name": "信长天下布武 - Hero Games Store",
  "short_name": "信长天下布武 - Hero Games Store",
  "start_url": `${baseUrl}/nobunaga`,
  "scope": `${baseUrl}/nobunaga`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": ICONS
}

const manifestTopup = {
  "name": "DUET NIGHT ABYSS",
  "short_name": "DUET NIGHT ABYSS",
  "start_url": `${baseUrl}/topup`,
  "scope": `${baseUrl}/topup`,
  "display": "standalone",
  "background_color": "#ffffff",
  "icons": [
    {
      "src": `${CommonConstants.MALL_STATIC_URL}/topup-192.png`,
      "sizes": "192x192",
      "type": "image/png"
    },
    {
      "src": `${CommonConstants.MALL_STATIC_URL}/topup-512.png`,
      "sizes": "512x512",
      "type": "image/png"
    }
  ]
}
// 이터널 에볼루션
export const manifestMap: Record<string, any> = {
  '/': CommonConstants.IS_CN ? manifestCn : manifestGlobal,
  "/wpzz": manifestWpzz,
  '/cncm': manifestCncm,
  '/dna': manifestDna,
  "/ee": manifestEe,
  // "/auroria": manifestAuroria,
  "/lios": manifestLios,
  "/lioslite": manifestLioslite,
  "/sd2": manifestSd2,
  "/shinsangokushi": manifestShinsangokushi,
  "/shinsangokushinew": manifestShinsangokushinew,
  "/twee": manifestTwee,
  "/twwtb": manifestTwwtb,
  "/topup": manifestTopup,
  "/nobunaga": manifestNobunaga,
  "/kree": manifestKree,
}
